import Trans from 'next-translate/Trans';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { memo } from 'react';

import useLinkProps from '../../../hooks/use-link-props';
import FeaturedLink from '../../ui/links/featured';

type TWarningMorePartsWihoutCarProps = {
  others_with_reference: TProductSearch['others_with_reference'];
  reference: TProductSearch['search']['reference'];
  isAdvanced?: boolean;
};

const WarningMorePartsWihoutCar = ({
  others_with_reference = 0,
  reference,
  isAdvanced = false,
}: TWarningMorePartsWihoutCarProps) => {
  const { locale = 'en', query } = useRouter();
  const getLink = useLinkProps();

  const NewSearchButton = memo(function NewSearchButton({ children }) {
    const { vehicle, ...newQuery } = query;
    const newLink = getLink(
      isAdvanced ? 'advanced-search-products-search' : 'search',
      newQuery
    );

    return (
      <Link {...newLink} legacyBehavior>
        <FeaturedLink>{children}</FeaturedLink>
      </Link>
    );
  });

  return (
    <div className="">
      <div>
        <Trans
          i18nKey="products:moreResults"
          values={{
            count: others_with_reference.toLocaleString(locale),
            reference: reference,
          }}
          components={{
            strong: <b />,
            link: <NewSearchButton />,
          }}
        />
      </div>
      <div className="pt-2">
        <Trans
          i18nKey="products:moreResults1"
          values={{
            count: others_with_reference.toLocaleString(locale),
            reference: reference,
          }}
          components={{
            strong: <b />,
            link: <NewSearchButton />,
          }}
        />
      </div>
    </div>
  );
};
export default WarningMorePartsWihoutCar;
